module.exports = __webpack_public_path__ + "img/edit.0707a7f9.svg";